import { ApplicationRef } from '@angular/core';
import { MonoTypeOperatorFunction, Observable } from 'rxjs';

// Ensures a change detection cycle runs after each emission. Use at service
// boundaries where data may arrive via a chain that originated outside NgZone
// (e.g. NgRx store emissions triggered by effects whose upstream scheduler is
// not zone-patched). Without this, property mutations in downstream subscribe
// callbacks won't trigger change detection and the view won't update until
// something unrelated (like a user click) causes a tick.
export function triggerCD<T>(appRef: ApplicationRef): MonoTypeOperatorFunction<T> {
    return source =>
        new Observable<T>(subscriber =>
            source.subscribe({
                next: value => {
                    subscriber.next(value);
                    appRef.tick();
                },
                error: err => subscriber.error(err),
                complete: () => subscriber.complete(),
            })
        );
}
